import { render, staticRenderFns } from "./ConfigAlertChatwork.vue?vue&type=template&id=26610a52&"
import script from "./ConfigAlertChatwork.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertChatwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports